export function formatPassSlipDate(d) {
  if (!d) return "—";
  const raw = String(d).slice(0, 10);
  return new Date(`${raw}T00:00:00`).toLocaleDateString("en-PH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatPassSlipDateTime(d) {
  if (!d) return "—";
  return new Date(d).toLocaleString("en-PH", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatPassSlipTime12(t) {
  if (!t) return "—";
  const [h, m] = String(t).split(":");
  const hr = parseInt(h, 10);
  const ampm = hr >= 12 ? "PM" : "AM";
  const h12 = hr % 12 || 12;
  return `${h12}:${m || "00"} ${ampm}`;
}

export function passSlipTimeAwayText(slip) {
  if (!slip) return "—";
  const date = formatPassSlipDate(slip.date_from);
  if (!slip.time_out) return date;
  if (slip.do_not_return) {
    return `${date} · ${formatPassSlipTime12(slip.time_out)} (no return)`;
  }
  if (slip.time_in) {
    return `${date} · ${formatPassSlipTime12(slip.time_out)} – ${formatPassSlipTime12(slip.time_in)}`;
  }
  return `${date} · ${formatPassSlipTime12(slip.time_out)}`;
}

export function passSlipVerifyUrl(referenceNo, sig) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const params = new URLSearchParams({
    ref: referenceNo || "",
    sig: sig || "",
  });
  return `${origin}/verify/pass-slip?${params.toString()}`;
}

async function passSlipPdfErrorMessage(error, fallback) {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data === "string") return data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed.message || fallback;
    } catch (e) {
      return fallback;
    }
  }
  return data.message || fallback;
}

/** Fetch official pass slip PDF and open it in a new tab (no editable preview page). */
export async function openPassSlipPdf(id) {
  const axios = (await import("axios")).default;
  const response = await axios.get(`api/leave-pass-slips/${id}/print-pdf`, {
    responseType: "blob",
  });

  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="([^"]+)"/i);
  const filename = match ? match[1] : `PassSlip_${id}.pdf`;
  const blobUrl = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));

  const win = window.open(blobUrl, "_blank");
  if (!win) {
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    link.click();
  }

  window.setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
  return filename;
}

export async function openPassSlipPdfSafe(id) {
  try {
    return await openPassSlipPdf(id);
  } catch (error) {
    const message = await passSlipPdfErrorMessage(error, "Could not open pass slip PDF.");
    throw new Error(message);
  }
}
